<div class="row">
  <div class="col-12">
    <sb-card [loading]="false">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}"
                         icon="basicSettings" [active]="true">
            <div class="wizard__forms p-5">
              <div class="row">
                <h3 *ngIf="weeklyScheduleId === -1">{{'nav.weeklySchedule.create' | translate}}</h3>
                <h3 *ngIf="weeklyScheduleId > -1">{{'nav.weeklySchedule.edit' | translate}}</h3>
              </div>

              <form *ngIf="!loading && weeklySchedule" [formGroup]="form" style="margin-left:-12px;">
                <div class="row mt-3">
                  <div class="col-md-3">
                    <div class="form-group validateMe">
                      <label for="Name">{{'lang.globals.name' | translate}}</label>
                      <input type="text" id="Name" class="form-control" formControlName="Name" sbAutofocus>
                      <div *ngIf="Name.touched && Name.errors?.required" class="alert alert-danger">
                        {{'lang.globals.nameWarning' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group validateMe">
                      <label for="Description">{{'lang.globals.description' | translate}}</label>
                      <input type="text" id="Description" class="form-control" formControlName="Description">
                      <div *ngIf="Description.touched && Description.errors?.required" class="alert alert-danger">
                        {{'lang.globals.descriptionWarning' | translate}}</div>
                    </div>
                    <div class="form-group">
                      <label for="Suggestion">{{'lang.globals.suggestion' | translate}}</label>
                      <div id="Suggestion" class="d-flex justify-content-between align-items-center w-100">
                        <div>{{suggestion}}</div>
                        <button class="btn btn-default" (click)="applySuggestion()" [ngbTooltip]="'lang.globals.suggestionApply'|translate"
                                container="body">
                          <sb-icon icon="paste"></sb-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngFor="let dayKey of weeklyScheduleService.dayKeys; let i = index;" class="mt-5">
                  <div class="row m-0 align-items-baseline">
                    <div class="col-1 pl-0">
                      <span class="day-label">{{ 'lang.globals.weekday.' + dayKey | translate }}</span>
                    </div>
                    <div class="col-2" *ngIf="!weeklySchedule[dayKey]">
                        <span style="font-style: italic;" class="tw-opacity-50">{{ 'lang.weeklySchedule.noRanges'| translate }}</span>
                    </div>
                    <div class="col-2" *ngIf="weeklySchedule[dayKey]">
                      <div class="d-flex align-items-center" [ngClass]="{'mt-1' : (r > 0)}"
                           *ngFor="let hourRange of weeklySchedule[dayKey]?.intervals; let r = index;">
                        <div class="validateMe">
                          <input type="time"
                                 [formControlName]="dayKey + '_' + r + '_from'"
                                 [value]="getTimeString(dayKey, r, 'from')"
                                 (focusout)="onChange(dayKey, r, 'from', $event)"
                                 [class]="'form-control ' + (hasError(dayKey, r, 'from')  ? 'border border-danger text-danger' : '') ">
                        </div>
                        <span class="separator"></span>
                        <div class="validateMe">
                          <input type="time"
                                 [formControlName]="dayKey + '_' + r + '_till'"
                                 [value]="getTimeString(dayKey, r, 'till')"
                                 (focusout)="onChange(dayKey, r, 'till', $event)"
                                 [class]="'form-control ' + (hasError(dayKey, r, 'till')  ? 'border border-danger text-danger' : '') ">
                        </div>
                        <a class="noselect hoverbg" (click)="removeTimeRange(dayKey, r)">
                          <sb-icon style="font-size: 8px;" class="m-0 p-3 hoverbg" icon="cancel"></sb-icon>
                        </a>
                      </div>
                      <div *ngIf="!hasValidRanges(dayKey)"
                           class="alert alert-danger">{{ 'lang.openingHour.timeOverlapError' | translate }}</div>
                    </div>
                    <a class=" col-2 item-link noselect btn-add hoverbg mt-2 mt-sm-0" (click)="addTimeRange(dayKey)">
                      {{'lang.weeklySchedule.addTime' | translate}}
                    </a>
                  </div>
                </div>
              </form>

              <div class="wizard__footerActions">
                <button type="button" (click)="util.returnToNavigation(util.RoutingID.weeklySchedule)"
                           class="btn btn-default btn-lg btn-wide">
                  {{'lang.globals.cancel' | translate}}
                </button>
                <button class="btn btn-success btn-wide btn-lg" type="button" [disabled]="!cycleValid|| loading" (click)="submit()">
                  {{'lang.globals.save' | translate}}
                </button>
              </div>
            </div>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
